"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInjectSaga = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("./_constants");
var _sagaInjectors = _interopRequireDefault(require("./sagaInjectors"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * A react hook that dynamically injects a saga when the hook is run
 *
 * @param {Object} params
 * @param {string} params.key The key to inject the saga under
 * @param {function} params.saga The saga that will be injected
 *
 * @example
 *
 * function BooksManager() {
 *   useInjectSaga({ key: "books", saga: booksSaga })
 *
 *   return null;
 * }
 *
 * @returns {boolean} flag indicating whether or not the saga has finished injecting
 * @public
 */
const useInjectSaga = _ref => {
  let {
    key,
    saga
  } = _ref;
  const store = (0, _reactRedux.useStore)();
  (0, _react.useLayoutEffect)(() => {
    (0, _sagaInjectors.default)(store).injectSaga(key, {
      saga,
      mode: _constants.SagaInjectionModes.COUNTER
    });
    return () => (0, _sagaInjectors.default)(store).ejectSaga(key);
  }, [key, saga, store]);
};
exports.useInjectSaga = useInjectSaga;
useInjectSaga.propTypes = {
  key: _propTypes.default.string,
  saga: _propTypes.default.func
};